export default __webpack_public_path__ + "static/media/0092.17559d63.jpg";